'use client'

import { useEffect, useState } from 'react'

const DISMISS_KEY = 'pwa-update-dismissed-at'
const DISMISS_COOLDOWN_MS = 6 * 60 * 60 * 1000 // 6h

export function PwaUpdateBanner() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const onUpdate = () => {
      const dismissed = Number(localStorage.getItem(DISMISS_KEY) ?? 0)
      if (Date.now() - dismissed < DISMISS_COOLDOWN_MS) return
      setShow(true)
    }
    window.addEventListener('pwa-update-available', onUpdate)
    return () => window.removeEventListener('pwa-update-available', onUpdate)
  }, [])

  if (!show) return null

  const handleUpdate = () => {
    navigator.serviceWorker?.controller?.postMessage({ type: 'SKIP_WAITING' })
    setTimeout(() => window.location.reload(), 300)
  }
  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()))
    setShow(false)
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-2xl shadow-xl p-4 flex items-center gap-3 animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div className="text-2xl">✨</div>
      <div className="flex-1">
        <p className="text-sm font-bold text-zinc-900 dark:text-zinc-100">Nova versão disponível</p>
        <p className="text-xs text-zinc-500 dark:text-zinc-400">
          Atualize pra pegar últimas melhorias.
        </p>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className="text-xs text-zinc-500 hover:text-zinc-700 px-2"
      >
        Depois
      </button>
      <button
        type="button"
        onClick={handleUpdate}
        className="text-xs font-bold px-3 py-1.5 rounded-full bg-blue-600 text-white hover:bg-blue-700"
      >
        Atualizar
      </button>
    </div>
  )
}
